export var getWindowHeight = function getWindowHeight() {
  return global.innerHeight;
};